import type { FuelEconomyDisplayMetric, FuelEconomyMetric } from '../store/selectors.types';

/**
 * Resolves a single fuel economy metric for display: the standard field wins, otherwise the
 * MPGe equivalent field is used, and a metric with neither populated resolves to no value.
 *
 * @param value - Standard fuel economy reading in mpg
 * @param equivalent - Equivalent (MPGe) reading, populated for electric and hybrid vehicles
 * @returns The display value paired with the unit it is measured in
 */
export const toFuelEconomyMetric = (value?: number, equivalent?: number): FuelEconomyMetric => {
    if (value) {
        return { value, unit: 'mpg' };
    }
    if (equivalent) {
        return { value: equivalent, unit: 'MPGe' };
    }
    return { unit: 'mpg' };
};

/**
 * Pairs a resolved metric with the label it renders with, calling out the unit only when the
 * metric resolved from the MPGe equivalent field.
 *
 * @param label - Base label for the metric, e.g. City
 * @param metric - Resolved metric the label describes
 * @returns The metric with its display label
 */
export const toDisplayMetric = (label: string, metric: FuelEconomyMetric): FuelEconomyDisplayMetric => ({
    ...metric,
    label: metric.unit === 'MPGe' ? `${label} (MPGe)` : label
});
